module.exports = __webpack_public_path__ + "static/media/error-auth.e8fbaa0b.svg";